export class SlideInElementContextualInformer {
	constructor(initiator) {
		this.initiator = initiator;
	}

	/**
	 * Provide a list of any universal contextual elements that should be taken
	 * into consideration for the positioning of a slide-in element.
	 *
	 * @returns {array}
	 */

	getContextualElements() {
		return [
			this.getWishlistDrawer(),
			this.getStudyPageBottomBanner(),
			this.getStudyPageBottomBannerTooltip(),
			this.getArticleSidebar()
		];
	}

	getCurrentPage() {
		const url = window.location.pathname;
		const urls = url.split('/');
		if (urls.length < 2) {
			return;
		}

		return urls[1];
	}

	/**
	 * Getter for contextual information (about the wishlist drawer) that a slide-in
	 * element needs to take into account for positioning.
	 *
	 * @returns {object}
	 */

	getWishlistDrawer() {
		return {
			element: {
				selector: '#wishlistDrawer.Opened #wishlistDrawerContent',
				isActive: () => document.querySelector('#wishlistDrawer.Opened') !== null
			},
			pages: [],
			listeners: [
				{
					selector: 'document',
					action: 'openWishlistDrawer'
				},
				{
					selector: 'document',
					action: 'closeWishlistDrawer'
				}
			],
			motion: {
				direction: 'horizontal',
				timing: 400
			}
		};
	}

	getStudyPageBottomBanner() {
		return {
			element: {
				selector: '#FixedEssentialInformation',
				isActive: () => {
					const banner = document.querySelector('#FixedEssentialInformation.is-inView');
					return banner !== null && this.isMobileBreakpoint();
				}
			},
			pages: ['studies'],
			listeners: [
				{
					selector: 'window',
					action: 'scroll'
				},
				{
					selector: 'window',
					action: 'resize'
				}
			],
			motion: {
				direction: 'vertical',
				timing: 300
			}
		};
	}

	getStudyPageBottomBannerTooltip() {
		return {
			element: {
				selector: '#FixedEssentialInformation',
				extraOffset: 72,
				isActive: () => {
					const banner = document.getElementById('FixedEssentialInformation');
					const tooltip = document.querySelector('.Tooltip.Guidance');
					return banner && this.isMobileBreakpoint() && tooltip && tooltip.style.display !== 'none';
				}
			},
			pages: ['studies'],
			listeners: [
				{
					selector: '.Tooltip.Guidance .TooltipCloseIcon',
					action: 'click'
				},
				{
					selector: 'window',
					action: 'scroll'
				}
			],
			motion: {
				direction: 'vertical',
				timing: 300
			}
		};
	}

	getArticleSidebar() {
		return {
			element: {
				selector: '#StudySearchOnArticlePage',
				isActive: () => {
					const sidebar = document.getElementById('StudySearchOnArticlePage');
					if (!sidebar) {
						return false;
					}

					return window.getComputedStyle(sidebar).position === 'fixed';
				}
			},
			pages: ['articles'],
			listeners: [
				{
					selector: 'window',
					action: 'scroll'
				}
			],
			motion: {
				direction: 'vertical',
				timing: 0
			}
		};
	}

	isMobileBreakpoint() {
		return Shared.breakpoints(['Small', 'Medium']);
	}
}

window.SlideInElementContextualInformer = SlideInElementContextualInformer;
